import { useState, useEffect } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useCountsCisNoso = () => {
  const [counts, setCounts] = useState({
    cis_noso: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const { data } = await axiosApi.get('/cisNoso/getCounts');
        setCounts({ cis_noso: data?.cis_noso || 0 });
      } catch (err) {
        setError(err.message || err?.toString());
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, loading, error };
};

export default useCountsCisNoso;
